import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import QuizFeed from "./QuizFeed";
import ModalPortal from "../../../Portal";
import ModalTwo from "../../../components/ModalTwo";
import API from "../../../config";
import quizData from "../QuizData.json";

const Quiz = () => {
  const location = useLocation();
  const name = location.state.name;

  const [count, setCount] = useState(1);
  const [time, setTime] = useState("0000-0000");
  const [quizFeed, setQuizFeed] = useState([]);
  const [modalOn, setModalOn] = useState(false);
  const [quizIndex, setQuizIndex] = useState(0);
  const [quizResult, setQuizResult] = useState([]);

  const selectRandomQuiz = quizData => {
    let arr = [];
    let ret = [];
    while (arr.length < 5) {
      let r = Math.floor(Math.random() * quizData.length);
      if (arr.indexOf(r) === -1) {
        arr.push(r);
        ret.push(quizData[r]);
      }
    }
    return ret;
  };

  const filterQuiz = quizFeed.filter((_, index) => {
    return index === quizIndex;
  });

  const previousBtn = () => {
    if (quizIndex < 0) return;
    setQuizIndex(current => current - 1);
  };

  const nextBtn = () => {
    if (quizIndex > 5) return;
    setQuizIndex(current => current + 1);
  };

  const resultFilter = quizResult.filter(el => {
    return el.choice_id === "";
  });

  const handleModal = () => {
    if (resultFilter.length !== 0) return;
    setModalOn(!modalOn);
  };

  const getQuiz = async () => {
    const response = await fetch(`${API.quiz}`);
    const response_json = await response.json();
    const result = await response_json.quizzes;
    return result;
  };

  useEffect(() => {
    quizFeed.map(ele => {
      setQuizResult(prev => [
        ...prev,
        {
          quiz_id: Number(ele.quiz_id),
          choice_id: "",
          answer_id: ele.answer_id,
        },
      ]);
    });
  }, [quizFeed]);

  useEffect(() => {
    // getQuiz().then(data => setQuizFeed(data));
    setQuizFeed(selectRandomQuiz(quizData));
    const timer = setInterval(currentDate, 1000);
    return () => clearInterval(timer);
  }, []);

  const currentDate = () => {
    const now = new Date();
    const yearNow = String(now.getFullYear());
    const year = yearNow;
    const monthNow = String(now.getMonth() + 1);
    const month = monthNow;
    const dateNow = String(now.getDate());
    const date = dateNow;
    setTime(
      `${year}${month >= 10 ? month : "0" + month}${
        date >= 10 ? date : "0" + date
      }`
    );
  };

  const addPlus = () => {
    if (count === 5) {
      setCount(0);
    } else {
      setCount(count + 1);
    }
  };

  const addMinus = () => {
    if (count === 0) {
      setCount(5);
    } else {
      setCount(count - 1);
    }
  };

  // console.log("quizFeed: ", quizFeed);
  // console.log("quizResult: ", quizResult);

  return (
    <QuizContainer>
      <QuizBox>
        <div>
          <QuizTitle>시놀 추억 탐구영역 능력 평가</QuizTitle>
          <QuizSubTitle>학력고사</QuizSubTitle>
          <QuizInputCtn>
            <QuizFirstInput>
              <QuizName>이름</QuizName>
              <QuizNameInput>{name}</QuizNameInput>
            </QuizFirstInput>
            <QuizSecondInput>
              <QuizUserNum>수험번호</QuizUserNum>
              <QuizUserNumInput>
                <Time>{time[0]}</Time>
                <Time>{time[1]}</Time>
                <Time>{time[2]}</Time>
                <Time>{time[3]}</Time>
                <Time>&#45;</Time>
                <Time>{time[4]}</Time>
                <Time>{time[5]}</Time>
                <Time>{time[6]}</Time>
                <Time>{time[7]}</Time>
              </QuizUserNumInput>
            </QuizSecondInput>
          </QuizInputCtn>
        </div>
        <QuizLine />
        <Container>
          <Progress width={(count / 5) * 100 + "%"} />
        </Container>
        {filterQuiz.map(quiz => (
          <QuizFeed
            key={quiz.quiz_id}
            quiz={quiz}
            quizResult={quizResult}
            setQuizResult={setQuizResult}
            quizIndex={quizIndex}
            addPlus={addPlus}
            nextBtn={nextBtn}
            modalOn={modalOn}
            setModalOn={setModalOn}
            resultFilter={resultFilter}
          />
        ))}
        <QuizPageBtnBox>
          {quizIndex > 0 ? (
            <Before
              onClick={() => {
                addMinus();

                previousBtn();
              }}
            >
              이전
            </Before>
          ) : (
            <Before style={{ opacity: 0, cursor: "default" }}>이전</Before>
          )}
          <PageNum>{count}/5</PageNum>
          {quizIndex < 4 && (
            <After
              onClick={() => {
                addPlus();
                nextBtn();
              }}
            >
              다음
            </After>
          )}
          {quizIndex === 4 && (
            <ModalBtn onClick={handleModal}>제출하기</ModalBtn>
          )}
          {modalOn && (
            <ModalPortal>
              <ModalTwo
                show={modalOn}
                onHide={() => setModalOn(false)}
                content={SUBMIT}
                quizresult={quizResult}
                name={name}
                time={time}
              />
            </ModalPortal>
          )}
        </QuizPageBtnBox>
      </QuizBox>
    </QuizContainer>
  );
};

export default Quiz;

const QuizContainer = styled.div`
  ${props => props.theme.variables.flex("", "center", "")}
  width: 1000px;
  margin: 0 auto;
  background-color: #ececec;

  @media screen and (max-width: 1000px) {
    width: 100vw;
  }
  @media screen and (max-width: 900px) {
    font-size: 14px;
  }
  @media screen and (max-width: 700px) {
    font-size: 12px;
  }
  @media screen and (max-width: 500px) {
    font-size: 10px;
  }
  @media screen and (max-width: 300px) {
    font-size: 8px;
  }
`;

const QuizBox = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 4em 3em;
`;

const QuizTitle = styled.p`
  font-family: ${props => props.theme.style.yangjin};
  color: ${props => props.theme.style.darkGrey};
  margin-bottom: 1em;
  text-align: center;
  font-size: 2em;
`;
const QuizSubTitle = styled.p`
  font-family: ${props => props.theme.style.yangjin};
  font-size: 5em;
  text-align: center;
  margin-bottom: 0.5em;
`;

const QuizInputCtn = styled.div`
  ${props => props.theme.variables.flex("", "space-between", "center")}
`;

const QuizFirstInput = styled.div`
  ${props => props.theme.variables.flex("", "space-between", "center")}
  border: 1px solid black;
  width: 35%;
  height: 3em;
  white-space: nowrap;
`;

const QuizName = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")}
  font-family: ${props => props.theme.style.yangjin};
  width: 100%;
  height: 100%;
`;

const QuizNameInput = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")}
  font-family: ${props => props.theme.style.yangjin};
  width: 100%;
  height: 100%;
  padding: 0 1em;
  border-left: 1px solid black;
`;

const QuizSecondInput = styled.div`
  ${props => props.theme.variables.flex("", "space-evenly", "center")}
  width: 60%;
  height: 3em;
  border: 1px solid black;
  white-space: nowrap;
`;

const Time = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")}
  width: 100%;
  height: 100%;
  border-left: 1px solid black;
`;

const QuizUserNum = styled.div`
  font-family: ${props => props.theme.style.yangjin};
  text-align: center;
`;

const QuizUserNumInput = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")}
  font-family: ${props => props.theme.style.yangjin};
  width: 80%;
  height: 100%;
  text-align: center;
`;

const QuizLine = styled.div`
  width: 100%;
  margin-top: 2.5em;
  border-bottom: 5px double black;
`;

const QuizPageBtnBox = styled.div`
  ${props => props.theme.variables.flex("", "space-between", "center")}
  position: relative;
  width: 100%;
  margin-top: 5em;
`;

const Before = styled.button`
  background-color: ${props => props.theme.style.black};
  color: ${props => props.theme.style.white};
  width: 25%;
  height: 4em;
  border: none;
  border-radius: 0.5em;
`;

const PageNum = styled.div`
  font-size: 2em;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
`;

const After = styled.button`
  background-color: ${props => props.theme.style.black};
  color: ${props => props.theme.style.white};
  width: 25%;
  height: 4em;
  border: none;
  border-radius: 0.5em;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 2em;
  margin: 2em auto;
  border: 2px solid red;
  border-radius: 1em;
  background-color: #eee;
`;

const Progress = styled.div`
  width: ${props => props.width};
  height: 100%;
  border-radius: 1em;
  background-color: red;
  transition: width 1s;
`;

const ModalBtn = styled.button`
  background-color: ${props => props.theme.style.red};
  color: ${props => props.theme.style.white};
  width: 25%;
  height: 4em;
  border: none;
  border-radius: 0.5em;
`;

const SUBMIT = {
  mainTitle: "시험을 종료합니다",
  subTitle: "제출 후에는 수정이 불가합니다.",
  btnText: "제출하기",
};
